import Vue from "vue";
import { SET_USER_INFO } from "../mutation-types";
import $ from "jquery";

// initial state
const initUser = {
  avatar: null,
  award_days: 0,
  calling_code: null,
  changed: false,
  email: null,
  email_verified: false,
  expire_at: 0,
  value_of_expire_in: 0,
  unit_of_expire_in: "D",
  gfwlist_url: null,
  id: 0,
  invitation_code: null,
  invitation_count: null,
  commission_invitation_code: null,
  commission_invitation_count: 0,
  itunes_subscribed: false,
  itunes_subscription_cancelled: false,
  max_device_count: 1,
  need_set_password: false,
  nickname: "",
  phone_num: null,
  role: null,
  has_password: true,
};

let state = {};
$.extend(state, initUser);

const mutations = {
  [SET_USER_INFO](state, userInfo) {
    for (let userAttr in state) {
      state[userAttr] = userInfo[userAttr];
    }
    window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
  resetUserInformation(state) {
    $.extend(state, initUser);
  },
};

const actions = {
  getUserInformation({ commit }, noCache) {
    let token = window.localStorage.getItem("token");
    let clientToken = window.localStorage.getItem("clientToken");
    return new Promise((resolve, reject) => {
      if (token !== null && clientToken === null) {
        Vue.http
          .get("api/user", {
            headers: {
              "Cache-Control": noCache ? "no-cache" : "private",
            },
          })
          .then((response) => {
            resolve(response);
            if (response.data.code === 0) {
              commit(SET_USER_INFO, response.data.data);
            } else {
              reject();
            }
            window.sessionStorage.removeItem("needUseNoCache");
          });
      }
    });
  },
};
export default {
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js